import React from 'react';

import { Ledger } from '../shared/cells';

// Amounts left out of the total: a captioned muted sub-ledger, or one muted line when all are zero.
const InfoLedger = ({ view, caption = 'Not charged' }) => {
  if (!view || !(view.items || []).length) return null;
  return (
    <div className={`tp-ov-info${view.collapsed ? ' tp-ov-info-zero' : ''}`}>
      {view.collapsed ? null : <div className="tp-ov-info-k">{caption}</div>}
      <Ledger items={view.items} />
    </div>
  );
};

export default InfoLedger;
